module.exports=function(){
    $(".award_list").hover(function () {
        $(this).find(".award_hide").addClass("award_current");
        $(this).find(".award_show").removeClass("award_current")
    },function () {
        $(this).find(".award_show").addClass("award_current");
        $(this).find(".award_hide").removeClass("award_current")
    });
    $(".dws_list").hover(function () {
        $(this).find(".dws_hide").addClass("dws_current");
        $(this).find(".dws_show").removeClass("dws_current")
    },function () {
        $(this).find(".dws_show").addClass("dws_current");
        $(this).find(".dws_hide").removeClass("dws_current")
    });
}